var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic_edit",
    "data-name": "ic edit",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_39",
    "data-name": "\\u77E9\\u5F62 39",
    width: 16,
    height: 16,
    transform: "translate(-10268 -9340)",
    fill: "#fff",
    stroke: "#6f6f6f",
    strokeWidth: 1.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_edit-2",
    "data-name": "ic edit",
    transform: "translate(10268 9340)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit-3",
    transform: "translate(-10269.6 -9341.151)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_41",
    "data-name": "\\u8DEF\\u5F84 41",
    d: "M9.6,16h7.2",
    fill: "none",
    stroke: "#6f6f6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_42",
    "data-name": "\\u8DEF\\u5F84 42",
    d: "M13.2,2.8a1.7,1.7,0,1,1,2.4,2.4l-10,10L2.4,16l.8-3.2Z",
    fill: "none",
    stroke: "#6f6f6f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.2ba65494e60fe5da0da1f7b6ef8f038f.svg";
export { ForwardRef as ReactComponent };